/* global wpApiSettings, $ */

import autosize from 'autosize';
import googleMapsApiLoader from 'google-maps-api-loader';
import formMessage from './form-message.js';

import { imageUpload } from '../index.js';

let $form;
let bounds = {};
let marker;
let map;
let geocoder;

function init() {

	$form = $('.form--place');

	if (!$form.length) {
		return;
	}

	imageUpload.init($form);
	initMap();

	const $description = $form.find('textarea');

	autosize($description);

	$description.textcounter({
		max: $description.data('limit'),
		counterText: `Tekstin pituus: %d / ${$description.data('limit')}`
	});

	$form.on('submit', (event) => {
		event.preventDefault();
		handleFormSubmit(event);
	});

	setPreviewLink();


}

function initMap() {

	googleMapsApiLoader({
		libraries: ['places'],
		apiKey: 'AIzaSyAgYWo4_VL_oAbM0ARvq6rStRUN1deK7R0'
	}).then((googleApi) => (

		new Promise((resolve, reject) => {

			geocoder = new googleApi.maps.Geocoder();

			geocoder.geocode({ address: 'Finland' }, (results, status) => {
				if (status === googleApi.maps.GeocoderStatus.OK) {
					// map.setCenter(results[0].geometry.location);
					bounds.finland = results[0].geometry.bounds;
					resolve(googleApi);
				} else {
					// console.warn('Geocoding failed', status);
					reject(status);
				}
			});

		})

	)).then((googleApi) => {

		map = new googleApi.maps.Map(document.getElementById('form__map-canvas'), {
			zoomControl: true,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false
			// draggable: false,
			// scrollwheel: false
		});

		map.fitBounds(bounds.finland);

		marker = new googleApi.maps.Marker({
			// draggable: true
		});

		const autocomplete = new googleApi.maps.places.Autocomplete(document.getElementById('autocomplete'), {
			types: ['geocode'],
			componentRestrictions: {
				country: 'fi'
			}
		});

		// Update Autocomplete region
		$('input[name="map-region-restrict"]').on('change', (event) => {
			if (event.target.checked) {
				autocomplete.setComponentRestrictions({
					country: event.target.value === 'all' ? [] : event.target.value
				});
			}
		});

        // When the user selects an address from the dropdown, populate the lat/lng
        // fields in the form and update the map.
		autocomplete.addListener('place_changed', () => {
			setLocation($form, autocomplete.getPlace());
		});


		googleApi.maps.event.addListener(map, 'click', function(event) {

			geocoder.geocode({ location: event.latLng }, (results, status) => {
				if (status === googleApi.maps.GeocoderStatus.OK) {
					setLocation($form, results[0], {
						lat: event.latLng.lat(),
						lng: event.latLng.lng()
					}, true);
				} else {
					// console.warn('Geocoding failed', status);
				}
			});

		});

		// Initial location

		const initialLat = parseFloat($form.find('input[name="fields[place__location_lat]"]').val());
		const initialLng = parseFloat($form.find('input[name="fields[place__location_lng]"]').val());

		if (initialLat && initialLng) {

			geocoder.geocode({ location: { lat: initialLat, lng: initialLng } }, (results, status) => {
				if (status === googleApi.maps.GeocoderStatus.OK) {
					setLocation($form, results[0], { lat: initialLat, lng: initialLng });
				} else {
					// console.warn('Geocoding failed', status);
				}
			});

		}

	});

}

function handleFormSubmit(event) {

	const data = new FormData($form.get(0));
	const actionUrl = $form.attr('action');

	let $formSubmit = $form.find('.form__submit');

	$formSubmit.prop('disabled', true).addClass('is--loading');

	$.ajax({
		url: actionUrl,
		method: 'POST',
		processData: false,
		contentType: false,
		beforeSend: (xhr) => {
			// xhr.setRequestHeader('Authorization', `Basic ' . ${btoa(username + ':' + password)}`);
			xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
		},
		data: data
	})
	.done((data, textStatus, jqXHR) => {

		const postType = 'place';

		if (jqXHR.status === 201) {

			window.history.replaceState({}, data.title, `${window.location.origin + window.location.pathname}?${postType}=${data.id}`);
			$form.attr('action', actionUrl + data.id);
			setPreviewLink(data.link);

			formMessage.handleEverything($form, 'Kohde lisätty!', 'success');

		} else if (jqXHR.status === 200) {

			formMessage.handleEverything($form, 'Muutokset tallennettu!', 'success');

		}

		$formSubmit.prop('disabled', false).removeClass('is--loading');

	})
	.fail((jqXHR, textStatus, errorThrown) => {
		formMessage.handleEverything($form, jqXHR.responseJSON.message, 'error');
		$formSubmit.prop('disabled', false).removeClass('is--loading');
	});

}

function setLocation($form, place, position, shouldKeepStill) {

	let lat;
	let lng;

	if (position) {
		lat = position.lat;
		lng = position.lng;
	} else {
		lat = place.geometry ? place.geometry.location.lat() : '';
		lng = place.geometry ? place.geometry.location.lng() : '';
	}

	if (!place.address_components) {
		return;
	}

	const locality = place.address_components.find((component) => (
		component.types.includes('locality')
		|| component.types.includes('administrative_area_level_1')
		|| component.types.includes('administrative_area_level_2')
		|| component.types.includes('administrative_area_level_3')
	));

	$form.find('input[name="fields[place__location_lat]"]').val(lat);
	$form.find('input[name="fields[place__location_lng]"]').val(lng);

	$form.find('input[name="fields[place__locality]"]').val(locality ? locality.long_name : '');

	if (place.geometry) {

		marker.setPosition({ lat, lng });
		marker.setMap(map);

		if (!shouldKeepStill) {
			map.setCenter(marker.getPosition());
			map.setZoom(14);
		}

	} else {
		marker.setMap(null);
	}

}

function setPreviewLink(itemURL) {

	const $link = $form.find('.form__preview-link');
	const url = itemURL || $link.data('href');

	if (url) {
		$link.attr('href', url).removeClass('disabled');
	}

}


export default {
	init
};
